import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-calculator',
  templateUrl: './layout-calculator.component.html',
  styleUrls: ['./layout-calculator.component.scss']
})
export class LayoutCalculatorComponent {}
